module.exports = __webpack_public_path__ + "img/sending_7.96a5ea21.png";